'use client';
import dynamic from 'next/dynamic';

import type { ErrorStatusType } from '@/app/types/error-layout';
import type { VehicleType } from '@/app/types/vehicle-type';

const ErrorLcv = dynamic(
  () => import('@/app/components/error-layout/lcv').then((mod) => mod.ErrorLcv),
  {
    ssr: false,
  }
);
const ErrorCv = dynamic(
  () => import('@/app/components/error-layout/cv').then((mod) => mod.ErrorCv),
  {
    ssr: false,
  }
);

interface ErrorProps {
  vehicleType: VehicleType;
  status: ErrorStatusType;
}

export const ErrorLayout = ({ vehicleType, status }: ErrorProps) => {
  const errorLayout = status === '500' ? 'error' : 'default';

  if (vehicleType === 'cv') {
    return <ErrorCv status={status} layout={errorLayout} />;
  }

  return <ErrorLcv status={status} layout={errorLayout} />;
};
